// extracted by mini-css-extract-plugin
module.exports = {"bg":"_27-AY","inlineContent":"_3qEHU","pageWrapper":"_3YpFi","shadow":"_3AC-I","leftTop":"_4Q7c1","rightTop":"_2mDVA","centerTop":"_3dHiF","innerBg":"_2L_ao"};